import { action } from '@/lib/api';
import pushChangesQueueItem from '@/redux/actions/pushChangesQueueItem';
import { store } from '@/redux/lib/configureStore';
import selectors from '@/redux/selectors/selectors';

const removePref = (key) => {
  action('uiRemovePref', { key });

  const state = store.getState();
  const userId = selectors.userId(state);
  pushChangesQueueItem('userPref', { userId, path: key, value: null, operation: 'delete' });
};

export default removePref;
